function moveAttribute(attr, a, b) {
  b.setAttribute(attr, a.getAttribute(attr))
  a.removeAttribute(attr)
}

export default function () {
  return function Plugin(fp) {
    return {
      onReady() {
        if (fp.altInput) {
          moveAttribute("id", fp.input, fp.altInput)
        }
      },
      onDestroy() {
        if (fp.altInput) {
          moveAttribute("id", fp.altInput, fp.input)
        }
      }
    }
  }
}
